/*
 * @Author: JakeChiu
 * @Email: zhaokai@staff.hexun.com
 * @GitHub: https://github.com/zhakei988
 * @Date: 2026-01-07 11:07:50
 * @LastEditTime: 2026-01-19 13:14:16
 * @Description: JakeChiu`s hxteam
 * @FilePath: \visualh5\src\mixins\micropayment.js
 */
export default {
    data() {
        // 存储
        return {
            // 是否是小额付款 1元以下，需要走新的支付流程
            isMicroPayent: false
        }
    },
    watch: {

    },
    methods: {
        /**
         * @description: 获取gteFinishtimeUtx参数
         * @return {*}
         */      
        getGteFinishtimeUtxParam(){
          const _this=this;
          var gteFinishtimeUtx,noRepeatPurchaseDays;
          var _item = _this.modelist[0]
          // 如果勾选了重复购买,需要判断是否买过
          if(_item.noRepeatPurchase){
            // 如果天数为空，则默认3天
            noRepeatPurchaseDays =
            _item.noRepeatPurchaseDays && _item.noRepeatPurchaseDays * 1 > 0
              ? _item.noRepeatPurchaseDays * 1
              : 3;
            // 计算N天前的日期
            gteFinishtimeUtx =
              new Date().getTime() - noRepeatPurchaseDays * 1000 * 24 * 60 * 60;
          }
          return  gteFinishtimeUtx;
        },
        /**
         * @description: 判断是否已经支付过
         * @return {*}
         */        
        isHasBeenPaid(params){
            const _this=this;
            const cbResult = {
                getpackageinfo:{},
                getuserordercount:{}
            }
            _this.getData(
                _this.apilist("getpackageinfo"),
                function (res) {
                  cbResult.getpackageinfo = res
                  if (res.respCode == "0") {
                    // 是否要校验已经购买过
                    if(params.isVerification){
                      let arrparams = [];
                      arrparams.push(params.groupid);
                      // 是否有绑定套餐
                      if (
                        res.result.bindPackageVOList &&
                        res.result.bindPackageVOList.length > 0
                      ) {
                        for (let i in res.result.bindPackageVOList) {
                          arrparams.push(res.result.bindPackageVOList[i].groupID);
                        }
                      }
                      var gteFinishtimeUtx = params.gteFinishtimeUtx&&params.gteFinishtimeUtx*1>0?params.gteFinishtimeUtx:_this.getGteFinishtimeUtxParam();
                      _this.getData(
                        _this.apilist("getuserordercount"),
                        function (res) {
                          cbResult.getuserordercount = res
                          params.callback(cbResult)
                        },
                        {
                          productid: arrparams.toString(),
                          orderStatus: 1,
                          onlyCheckOrderIsExist: 1,
                          gteFinishtimeUtx
                        },
                        3000
                      );                  
                    }else{
                      // 不需要校验已经购买过则直接回调
                      params.callback(cbResult)
                    }
                  } else {
                    params.callback(cbResult)
                  }
                },
                {
                  groupid:params.groupid,
                  getBindGroupInfo: 1,
                },
                3000
              );
        },
        /**
         * @description: 获取订单信息
         * @return {*}
         */
        getOrderDetaile(groupid,all) {
            const _this = this;
            return new Promise((resolve, reject) => {
                // 套餐需要获取套餐中全部id
                _this.getData(
                    _this.apilist("getpackageinfo"),
                    function (res) {
                        resolve(res)
                    },
                    {
                        groupid,
                        getBindGroupInfo:all?0:1,
                    },
                    3000
                );
            })
        },
        /**
         * @description: 获取订单信息
         * @return {*}
         */
        getUserCount(groupids) {
          const _this = this;
          return new Promise((resolve, reject) => {
            _this.getData(
              _this.apilist("getuserordercount"),
              function (res) {
                if (res.respCode=='0'&&res.result&&res.result.buytimes * 1 > 0) {
                  resolve(true)
                }else{
                  resolve(false)
                }
                //alert(JSON.stringify(res))
              },
              {
                productid: groupids.toString(),
                orderStatus: 1,
                onlyCheckOrderIsExist: 1,
                gteFinishtimeUtx:_this.getGteFinishtimeUtxParam()
              },
              3000
            );
          })
      },
        /**
         * @description: 获取ab测试默认a没变化，b走最新的小额支付链路
         * @return {*}
         */        
        getMicroPayentAbtest(){
            const _this=this;
            return new Promise((resolve, reject)=>{
                const _time = new Date().getTime();
                _this.getAbTest({
                    // 实验参数名称
                    param_name: "lianlu",
                    // 试验默认值
                    default_value: "A",
                    // 试验值类型
                    value_type: "String",
                    // 回调 返回值支持字符串、数字、布尔、对象、数组等类型,由产品在神策建立实验时确定
                    callback: (result) => {
                      // 请根据 result 进行自己的试验，当前试验对照组返回值为：a，试验组依次返回：b
                      // 获取用户命中的试验结果，针对用户可能命中的试验进行处理
                      if (new Date().getTime() - _time <= 1 * 1000) {
                        console.log("返回小额1元以下支付分组:", result);
                        if (result.toLowerCase() == "b") {
                          // 开启了权限并且为B组，执行倒计时并且看是否点击了购买等按钮
                          resolve(true)
                        }else{
                          resolve(false)
                        }
                      } else {
                        resolve(false)
                        console.log("返回实验分组:分组响应超过1秒,保持原方案");
                      }
                    },
                  })
            })
        }
    }
}